import { useEffect, useState } from 'react';
import { Address } from 'react-daum-postcode';

import Field from '@/components/common/Field/Field';
import InputAddress from '@/components/common/Input/InputAddress/InputAddress';
import InputSelect from '@/components/common/Input/InputSelect/InputSelect';
import InputText from '@/components/common/Input/InputText/InputText';
import { positionOptions } from '@/constants/option';
import { formatNumberOnly } from '@/utils/formatting';

import * as S from './style';
import { useSignUpStore } from '../SignUpContext/SignUpContext';

const CompanyInfoForm = () => {
	const [isOpen, setIsOpen] = useState(false);
	const { setStep, updateCompanyInfo, companyInfo, setCurrentStep } = useSignUpStore();
	const [company, setCompany] = useState({
		company_name: '',
		company_name_en: '',
		position: '',
		positionReason: '',
		phone: '',
	});
	const [address, setAddress] = useState({
		zipcode: '',
		address: '',
		detailAddress: '',
	});
	const handleAddress = (val: Address) => {
		setAddress({
			zipcode: val.zonecode,
			address: val.address,
			detailAddress: '',
		});
	};

	const onSubmit = () => {
		updateCompanyInfo({ ...company, position: company.position === '기타(직접입력)' ? company.positionReason : company.position, ...address });
		setStep('학력정보 입력');
		setCurrentStep('학력정보 입력');
	};

	useEffect(() => {
		const hasInfo = companyInfo.company_name || companyInfo.company_name_en || companyInfo.position || companyInfo.phone || companyInfo.fax;

		if (hasInfo) {
			setCompany({
				company_name: companyInfo.company_name ?? '',
				company_name_en: companyInfo.company_name_en ?? '',
				position: companyInfo.position ?? '',
				positionReason: '',
				phone: companyInfo.phone ?? '',
			});
			setAddress({
				zipcode: companyInfo.zipcode ?? '',
				address: companyInfo.address ?? '',
				detailAddress: companyInfo.detailAddress ?? '',
			});
		}
	}, [companyInfo]);

	return (
		<S.FormContainer>
			<S.FieldBox>
				<Field title="직장명(국문)">
					<InputText
						value={company.company_name}
						input={(e: React.ChangeEvent<HTMLInputElement>) => {
							setCompany({ ...company, company_name: e.target.value });
						}}
					/>
				</Field>
				<Field title="직장명(영문)">
					<InputText
						value={company.company_name_en}
						input={(e: React.ChangeEvent<HTMLInputElement>) => {
							setCompany({ ...company, company_name_en: e.target.value });
						}}
					/>
				</Field>
				<Field title="직위">
					<S.AddressContentBox>
						<InputSelect
							options={positionOptions}
							selectedOption={company.position}
							setSelectedOption={(label) => setCompany({ ...company, position: label })}
							defaultValue="직위선택"
						/>
						{company.position === '기타(직접입력)' && (
							<InputText
								value={company.positionReason}
								input={(e: React.ChangeEvent<HTMLInputElement>) => {
									setCompany({ ...company, positionReason: e.currentTarget.value });
								}}
								placeholder="직접 입력"
							/>
						)}
					</S.AddressContentBox>
				</Field>

				<Field title="전화 번호">
					<InputText
						input={(e: React.ChangeEvent<HTMLInputElement>) => {
							const value = formatNumberOnly(e);
							setCompany({ ...company, phone: value });
						}}
						value={company.phone}
						placeholder="‘-’없이 숫자만 입력"
					/>
				</Field>
				<Field title="주소">
					<S.AddressContentBox>
						<S.AddressBox>
							<InputText readonly value={address.zipcode} input={() => {}} />
							<S.FindButton type="button" onClick={() => setIsOpen(true)}>
								우편번호 찾기
							</S.FindButton>
						</S.AddressBox>
						<S.AddressBox>
							<InputText readonly value={address.address} input={() => {}} />
						</S.AddressBox>
						<S.AddressBox>
							<InputText
								value={address.detailAddress}
								placeholder="상세주소 입력"
								input={(e) => {
									setAddress({
										...address,
										detailAddress: e.target.value,
									});
								}}
							/>
						</S.AddressBox>
					</S.AddressContentBox>
				</Field>
			</S.FieldBox>
			<S.GuideBox>
				<S.GuideTextStrong>본 학회 학생회원 기준 : 학부생 ~ 석사과정생까지</S.GuideTextStrong>
				<S.GuideText>
					Part time은 일반회원으로 되며, 석박통합의 경우 5학기부터는 일반회원입니다.
					<br />
					<br />
					[일반회원 → 학생회원으로 변경 절차]
					<br />
					회원가입 후 로그인 → My → 재학인증 → 재학증명서 업로드 → 등록
					<br />
					추후 학회 사무국에서 재학증명서 확인 후 학생회원으로 변경진행
					<br />
					(재학증명서 업로드 후 학회 사무국 scsk1968@naver.com 메일 발송)
				</S.GuideText>
			</S.GuideBox>
			<S.NextButton type="submit" onClick={onSubmit}>
				다음
			</S.NextButton>
			{isOpen && <InputAddress setIsOpen={setIsOpen} setAddress={handleAddress} />}
		</S.FormContainer>
	);
};

export default CompanyInfoForm;
